/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonHomeTotalDelegationAmountInfo = {
    STKTP: BabylonHomeTotalDelegationAmountInfo.STKTP;
    TDLGAMT: string;
    TDLGVAL: string;
};

export namespace BabylonHomeTotalDelegationAmountInfo {

    export enum STKTP {
        BTC_STAKING = 'BTC_STAKING',
    }


}

